import React from 'react';
import { Modal, Button, Card } from '../ui';
import PayoutReceipt from '../features/PayoutReceipt';

/**
 * Game final / funds released notification — presentation only.
 */
export default function WinnerNotificationModal({ open, winner, autoReleased, onClose }) {
  if (!open || !winner || winner.isDraw) return null;

  const settlement = {
    totalPot: winner.totalPot,
    platformFeeRate: winner.platformFeeRate,
    platformFeeAmount: winner.platformFeeAmount ?? winner.platformFee,
    winnerPayoutAmount: winner.winnerPayoutAmount ?? winner.payoutAmount,
    subscriptionDiscountApplied: winner.subscriptionDiscountApplied,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      accent="brand"
      size="sm"
      bodyClassName="p-6 md:p-8"
      footer={(
        <Button type="button" fullWidth size="sm" onClick={onClose}>
          Close
        </Button>
      )}
    >
      <div className="text-center mb-6 space-y-4">
        <p className="text-xs font-black uppercase tracking-[0.2em] text-emerald-400">
          {winner.kind === 'funds_released' ? 'Earnings claimed' : 'Challenge settled'}
        </p>
        <p className="text-sm font-bold text-gray-400">{winner.description}</p>
        <Card variant="raised" padding="sm" rounded="2xl" className="text-left space-y-3 bg-black/50">
          <div>
            <p className="text-xs text-gray-600 font-black uppercase tracking-widest mb-0.5">
              Winning team
            </p>
            <p className="text-lg font-black text-emerald-500">{winner.winningTeam}</p>
          </div>
          <div>
            <p className="text-xs text-gray-600 font-black uppercase tracking-widest mb-0.5">
              Winning player
            </p>
            <p className="text-lg font-black text-white">{winner.winningPlayerName}</p>
          </div>
        </Card>
        <PayoutReceipt settlement={settlement} compact />
        {winner.kind !== 'funds_released' && !winner.isCustom && !autoReleased && (
          <p className="text-xs text-amber-400/90 font-bold">
            Only the winner can claim challenge earnings after the result is final.
          </p>
        )}
        {autoReleased && (
          <p className="text-xs text-emerald-400/90 font-bold">
            Live challenge — earnings were added to your wallet automatically.
          </p>
        )}
      </div>
    </Modal>
  );
}
